// extracted by mini-css-extract-plugin
export default {"toasts":"Toast_toasts__NJKOI","toast":"Toast_toast__nd-uy"};